import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { AmplitudeService } from '@inyova/inyova-shared';
import { StockCompanyWithWeight } from '@inyova/models';

import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as StrategyActions from '@strategy/strategy.actions';
import * as fromStrategy from '@strategy/reducers';

import { Company } from '@shared/models/Strategy';

@Component({
  selector: 'app-setup-portfolio-company-list',
  templateUrl: './setup-portfolio-company-list.component.html',
  styleUrls: ['./setup-portfolio-company-list.component.scss'],
  standalone: false
})
export class SetupPortfolioCompanyListComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Output() updateCompanyDetail = new EventEmitter<{ companyID: number; updated: boolean }>();
  @Input() appLocation: 'ch' | 'de';
  @Input() companyList: StockCompanyWithWeight[] = [];
  @Input() selectedCompanyID = 0;
  @Input() stepStatus: number;

  constructor(
    private store: Store,
    private amplitudeService: AmplitudeService
  ) {
    this.store.pipe(select(fromStrategy.selectExpandedCompanyId), takeUntil(this.onDestroy$)).subscribe((selectedCompanyID) => {
      this.selectedCompanyID = selectedCompanyID;
    });
  }

  trackByCompanyID(_index: number, company: Company): number {
    return company.id;
  }

  showCompany($event: Event, company: Company): void {
    if (($event.target as HTMLElement).classList.contains('company-action')) return;

    if (this.selectedCompanyID === company.id) {
      this.selectedCompanyID = null;
      return;
    }

    this.selectedCompanyID = company.id;
    this.store.dispatch(StrategyActions.setExpandedCompanyId({ companyId: company.id }));
    this.updateCompanyDetail.emit({ companyID: company.id, updated: true });
  }

  trackTooltip(name: string) {
    this.amplitudeService.trackEvent('Tooltip Info Consulted', {
      tooltip_name: name,
      screen: 'portfolio company',
      consultation_method: 'hover'
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
